import React from "react";

import LocIcon from "../../../assets/icons/locIcon.svg";
import TimeIcon from "../../../assets/icons/timeicon.svg";
import BagIcon from "../../../assets/icons/bagIcon.svg";
import PaperIcon from "../../../assets/icons/paperIcon.svg";
import CalenderIcon from "../../../assets/icons/calenderIcon.svg";
import EyeIcon from "../../../assets/icons/eyeIcon.svg";
import Logo from "../../../assets/logo.svg";


const jobs = [
  {
    id: 1,
    position: "Front End Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 101,
    views: 589,
  },
  {
    id: 2,
    position: "Front End Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 102,
    views: 589,
  },
  {
    id: 3,
    position: "UX UI Designer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 120,
    views: 589,
  },
  {
    id: 4,
    position: "Front End Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 120,
    views: 589,
  },
  {
    id: 5,
    position: "Front End Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 12,
    views: 589,
  },
  {
    id: 6,
    position: "SEO Expert",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 102,
    views: 589,
  },
  {
    id: 7,
    position: "Front End Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 120,
    views: 589,
  },
  {
    id: 8,
    position: "Front End Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 200,
    views: 589,
  },
  {
    id: 9,
    position: "Full Stack Developer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 120,
    views: 589,
  },
  {
    id: 10,
    position: "UX UI Designer",
    category: "Design",
    company: "Morph & Mind",
    location: "Miami, FL",
    // tags: ["Remote", "Full-time", "Intermediate"],
    level: "Intermediate",
    type: "Full-time",
    time: "Remote",
    description:
      "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    date: "June 02, 2024",
    resumNum: 120,
    views: 589,
  },
];

function CompanyJobs() {
  return (
    <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-5">
      {jobs.map((job) => (
        <div
          key={job.id}
          onClick={() => handleCardClick(job)}
          className="border border-gray-200 rounded-lg p-4 flex flex-col gap-3 cursor-pointer  shadow-sm hover:shadow-lg duration-150 transition"
          //   style={{
          //     boxShadow: " rgba(0, 0, 0, 0.16) 0px 1px 1px",
          //   }}
        >
          <div className="flex items-center justify-between">
            <div className="flex gap-2 items-center">
              <img
                src={Logo}
                className="w-7 h-7 rounded-full"
                alt="Company Logo"
              />
              <div className="flex flex-col gap-1">
                <div className="flex gap-2 items-baseline ">
                  <h2 className="text-gray-800 text-[16px] font-semibold ">
                    {job.position}
                  </h2>
                  <span className="border border-blue-300 bg-blue-100 text-blue-500 font-semibold px-3 py-1 rounded-xl text-[10px] flex gap-1 items-center">
                    <span> &bull; </span>
                    {job.category}
                  </span>
                </div>
                <div className="flex ">
                  <p className="text-gray-500 font-normal pr-2 text-xs border-r border-gray-500">
                    {job.company}
                  </p>
                  <p className="text-gray-500 font-normal text-xs  pl-2">
                    {job.location}
                  </p>
                </div>
              </div>
            </div>
            <button className="cursor-pointer text-gray-700 p-2 text-xl">
              &#x22EE;
            </button>
          </div>

          <div className="flex gap-3 items-center">
            <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
              <img src={LocIcon} alt="loc icon" className="w-4 h-4" />
              {job.type}
            </span>
            <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
              <img src={TimeIcon} alt="time icon" className="w-4 h-4" />
              {job.time}
            </span>
            <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
              <img src={BagIcon} alt="bag icon" className="w-4 h-4" />
              {job.level}
            </span>
          </div>

          <div className="pb-5 border-b border-gray-200">
            <p className="text-gray-500  font-normal text-xs leading-5">
              {job.description.split(" ").slice(0, 25).join(" ") + "..."}
            </p>
          </div>

          <div className="flex items-center gap-4 pt-1">
            <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
              <img src={CalenderIcon} alt="calender icon" className="w-4 h-4" />
              {job.date}
            </span>
            <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
              <img src={PaperIcon} alt="paper icon" className="w-4 h-4" />
              {job.resumNum > 100 ? 100 + "+" : job.resumNum}
            </span>
            <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
              <img src={EyeIcon} alt="eye icon" className="w-4 h-4" />
              {job.views}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CompanyJobs;